/** INSS × QI Tech. */

import { httpV1 as http } from '@/services/api';

export async function consult(params) {
  return http.get('/inss/balance', { params });
}

export async function confirm(params) {
  return http.get('/inss/simulation', { params });
}

export async function simulate(data) {
  return http.post('/inss/simulation', data);
}

export async function verify(params) {
  return http.get('/inss/proposal', { params });
}

export async function approve(data) {
  return http.post('/inss/approve', data);
}

export async function approveAfterVideoFulfillment(data) {
  return http.post('/inss/credit-operation', data);
}

export async function factor() {
  return http.get('/inss/factor');
}

export async function reSimulate(data) {
  return http.post('/inss/resimulate', data);
}

export async function bankAccount(params) {
  return http.get('/inss/in100-bank-account', { params });
}

export async function priority(data) {
  return http.put('/inss/priority-reservation', data);
}
